<template>
  <div class="assinar-documento container">
    <div class="linha">
      <h2>{{ nomeDoc }}</h2>
    </div>

    <form @submit.prevent="registrarAssinatura()">
      <div class="linha">
        <input
          v-model="form.nome"
          type="text"
          class="form-control tam-maximo"
          placeholder="Insira seu nome completo"
          minlength="5"
          :disabled="salvou"
          required
        >
      </div>

      <div class="linha">
        <input
          v-model="form.cpf"
          type="text"
          class="form-control tam-maximo"
          placeholder="Insira seu cpf"
          maxlength="14"
          minlength="14"
          :disabled="salvou"
          required
        >
      </div>

      <div class="linha">
        <button
          type="button"
          class="btn btn-default botao"
          v-if="form.documento_id"
          @click="visualizarDocumento()"
        >
          Visualizar Documento
        </button>
      </div>

      <div class="linha">
        <input
          class="checkbox"
          type="checkbox"
          id="concordar"
          name="concordar"
          :disabled="!habilitarSalvar || salvou"
          @click="validarFormulario"
          required
        >
        <label
          for="concordar"
          @click="validarFormulario"
        >
          Declaro que li e concordo com o documento
        </label>
      </div>

      <div v-if="!salvou" class="linha">
        <button
          type="submit"
          class="btn btn-success"
        >
          Assinar
        </button>
      </div>
    </form>

  </div>
</template>

<script>
import Utils from '@/mixins/utils.js';
import { cpf } from 'cpf-cnpj-validator';

export default {
  name: 'AssinarDocumento',

  mixins: [
    Utils,
  ],

  data() {
    return {
      habilitarSalvar: false,
      nomeDoc: '',
      documento: null,
      salvou: false,
      form: {
        nome: '',
        cpf: '',
        documento_id: null,
      }
    };
  },

  mounted() {
    this.obterDocumentoId();
  },

  watch: {
    'form.cpf'(value) {
      if (value.length < 11) {
        return
      }

      if (value.length > 14) {
        this.form.cpf = value.slice(0, 14)
      }

      this.form.cpf = cpf.format(value)
    }
  },

  methods: {
    obterDocumentoId() {
      this.nomeDoc = this.$route.params.nomeDoc;

      this.form.documento_id = this.CryptoJS.AES.decrypt(this.$route.params.doc, this.$root.chaveFront).toString(this.CryptoJS.enc.Utf8)
    },

    visualizarDocumento() {
      this.habilitarSalvar = true;
      window.open(`${this.$root.url}/documentos/download/${this.form.documento_id}`, '_blank')
    },

    validarFormulario() {
    if (!this.habilitarSalvar) {
        this.customAlert(
          'Atenção!',
          'Leia o documento para liberar a assinatura.',
          'warning'
        );
        return false;
      }

      return true;
    },

    registrarAssinatura() {
      if (!this.validarFormulario()) return;

      this.$events.$emit('loading', true);
      this.$http.post('/documentos/assinar', this.form);

      this.customAlert(
        'Sucesso!',
        'Sua assinatura foi registrada com sucesso!',
        'success'
      );
      this.salvou = true;
      this.$events.$emit('loading', false);
    }
  },
}
</script>

<style lang="scss" scoped>
.assinar-documento {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: auto;
  padding-top: 5vh;

  .linha {
    width: auto;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .checkbox {
    margin-bottom: 8px;
    margin-right: 5px;
  }

  .tam-maximo {
    max-width: 300px;
  }

  .botao {
    max-width: 170px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/documentos/AssinarDocumento.vue